__turbopack_context__.v({
  "action": "index-module-scss-module__5Z5fPq__action",
  "contentTable": "index-module-scss-module__5Z5fPq__contentTable",
  "header": "index-module-scss-module__5Z5fPq__header",
  "nopermission": "index-module-scss-module__5Z5fPq__nopermission",
  "subscribe": "index-module-scss-module__5Z5fPq__subscribe",
  "table": "index-module-scss-module__5Z5fPq__table",
  "years": "index-module-scss-module__5Z5fPq__years",
});
